import { environment } from '@curbnturf/environment';

/**
 * Web origins this build may complete Cognito sign-in on, besides the one
 * baked into cognitoCallback/baseUrl — e.g. production's v2/new hosts. Each
 * origin's /auth/redirect (sign-in) and bare origin (sign-out) must also be on
 * the Cognito app client's callback/sign-out URL lists, or Cognito rejects the
 * redirect. Only cnt-landing's environment defines this, hence the cast: libs
 * type @curbnturf/environment against curbnturf's environment.
 */
const COGNITO_WEB_ORIGINS: string[] =
  (environment as { cognitoWebOrigins?: string[] }).cognitoWebOrigins ?? [];

function allowedCurrentOrigin(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  const { origin } = window.location;
  return COGNITO_WEB_ORIGINS.includes(origin) ? origin : undefined;
}

/** The web sign-in callback for the host the user is on, else `fallback`. */
export function webCognitoCallback(fallback: string): string {
  const origin = allowedCurrentOrigin();
  return origin ? `${origin}/auth/redirect` : fallback;
}

/** The web sign-out return URL for the host the user is on, else `fallback`. */
export function webCognitoLogoutCallback(fallback: string): string {
  return allowedCurrentOrigin() ?? fallback;
}
